import React from 'react'
import { isGstValid, returnInputFieldLength } from '../../../../utils/commonFunctions';
type AppProps={
    success:number | null;
    gstDetails:any; 
    handleGstDetailsChange:(data:any)=>void;
    getGstDetails: (data: any) => void;
    isDisabled?:boolean
}
const GstDetails = ({
    success,
    gstDetails,
    handleGstDetailsChange,
    getGstDetails,
    isDisabled
}:AppProps) => {
    return (
        <>
            <div className="row ml-0">
                <p>Click button below to get GST details in form</p>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <div>
                                <label htmlFor="gstNumber"
                                >GST Number</label>
                                <input
                                    type="text"
                                    className={`form-control`}
                                    name="gstNumber"
                                    value={gstDetails?.gstNumber?gstDetails?.gstNumber:""}
                                    onChange={(e)=>handleGstDetailsChange(e)}
                                    maxLength={15}
                                    disabled={isDisabled}
                                />
                            </div>
                            <span className="input-length">
                                    {returnInputFieldLength(gstDetails?.gstNumber?.length, 15)}
                                </span>
                                {( success === 0) && (!!(gstDetails?.gstNumber?.length > 14) && <p style={{ color: "#e7733e", fontSize: '10px' }}>Invalid GST Number. Please try again.</p>)}
                                {/* {(!isGstValid(gstDetails?.gst)) && (!!(gstDetails?.gst?.length > 14) && <p style={{ color: "#e7733e", fontSize: '10px' }}>Invalid GST Number. Please try again.</p>)} */}
                        </div>
                    </form>
                </div>
                <div className='col-md-3 mt-4'>
                    <div className='form-group'>
                        <button className="btn btn-outline"

                        disabled={isDisabled || (gstDetails?.gstNumber?.length > 14 ? false : true)}
                        onClick={(e) => {
                            getGstDetails(gstDetails?.gstNumber)
                        }}
                        >Verify and Get</button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <label htmlFor="Legal Name"
                            >Legal Name</label>
                            <input
                                type='text'
                                name='legalName'
                                value={gstDetails?.legalName}
                                className={`form-control`}
                                onChange={(e) => handleGstDetailsChange(e)}
                                 disabled={isDisabled}
                            />
                        </div>
                    </form>
                </div>
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <label htmlFor="Trade Name"
                            >Trade Name</label>
                            <input
                                type='text'
                                name='tradeName'
                                className={`form-control`}
                                value={gstDetails?.tradeName}
                                onChange={(e) => handleGstDetailsChange(e)}
                                 disabled={isDisabled}
                            />
                        </div>
                    </form>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <label htmlFor="Registration Type"
                            >Registration Type</label>
                            <input
                                type='text'
                                disabled
                                name='registrationType'
                                value={gstDetails?.registrationType}
                                className={`form-control`}
                                
                            />
                        </div>
                    </form>
                </div>
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <label htmlFor="Registration Date"
                            >Registration Date</label>
                            <input
                                type='text'
                                name='registrationDate'
                                disabled
                                className={`form-control`}
                                value={gstDetails?.registrationDate}
                                
                            />
                        </div>
                    </form>
                </div>
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <label htmlFor="Constitution of Business"
                            >Constitution of Business</label>
                            <input
                                type='text'
                                disabled
                                className={`form-control`}
                                name='constitutionOfBusiness'
                                value={gstDetails?.constitutionOfBusiness}
                            />
                        </div>
                    </form>
                </div>
                <div className="col-md-3">
                    <form>
                        <div className="form-group">
                            <label htmlFor="Company Status"
                            >Company Status</label>
                            <input
                                type='text'
                                disabled
                                className={`form-control`}
                                name='companyStatus'
                                value={gstDetails?.companyStatus}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default GstDetails